import './add-item-form.scss'

import { faCircleNotch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { Config } from 'final-form';
import { debounce } from 'lodash';
import { Component } from 'vue-property-decorator';

import { Item, ItemDataStore, itemSelectors, MovementTypes, Wemi } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { LinkableItem } from '@skinsoft/entity-data-store';
import { BarcodeSubscriber, ItemCard } from '@skinsoft/ui';
import { first } from 'rxjs/operators';
import { BarcodeReader, Field, Form } from '../../../../ui';

export interface Values {
    location: string;
    identifier: string;
}

declare var ITEM_SEARCH_TYPES: string[];

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
        sBarcodeSubscriber: BarcodeSubscriber,
        sItemCard: ItemCard,
    },
    props: ['onSubmit', 'initialValues', 'movementType', 'itemsIdsToExclude'],
    template: require('./add-item-form.html'),
})
export class AddItemForm extends ReactiveVue {
    public onSubmit: Config['onSubmit'];
    public locations: Array<{ id: string; value: string; text: string }>;
    public initialValues: Values;
    public item: Item = null as any;
    public itemsIdsToExclude: LinkableItem[];
    public movementType: MovementTypes;

    public MovementTypes = MovementTypes;

    public $refs: {
        barcodeReader: BarcodeReader;
        form: Form;
        location: Field;
    };

    private searchPending = false;
    private debounce = debounce;
    private $itemDataStore: ItemDataStore;
    private errorMessage: string = "";
    private submitting: boolean = false;

    private readonly INPUT_FILTER_IDENTIFIER: string = "add-item-search-query-input"

    // Icons
    private undoIcon = faUndo;
    private loadingIcon = faCircleNotch;

    public async validate(values): Promise<any> {
        // need to be a promise to avoid conflict with $t mixin
        const errors = {} as any;
        const errorMessage = this.$t('entity.addItem.form.id.notFoundError') as string;

        if (!values.id) {
            this.errorMessage = this.$t('entity.addItem.form.id.emptyError') as string;
        }

        if (values.id) {
            try {
                this.searchPending = true;
                const matchingSearchResult = await this.$itemDataStore.searchOneWithText(values.id, ITEM_SEARCH_TYPES)

                const searchResultId = ItemDataStore.getItemSearchResultId(matchingSearchResult);
                if (this.itemsIdsToExclude && this.itemsIdsToExclude.find(linkableItem => linkableItem.linkableItem === searchResultId)) {
                    this.errorMessage = this.$t('entity.addItem.form.id.alreadyAdded') as string;
                    this.item = null as any;
                } else {
                    this.item = await this.$itemDataStore.fetchOne(searchResultId).pipe(first()).toPromise();
                    const form = this.$refs.form.form;
                    // Updating hidden fields, without re-performing a validation
                    form.getState().values.itemId = this.item.id;
                    form.getState().values.itemType = this.item.type;
                }
                this.searchPending = false;

            } catch (error) {
                this.searchPending = false;
                this.errorMessage = errorMessage;
                this.item = null as any;
            }
        }
        return errors;
    }

    public onBarcodeReaderInput(input: string) {
        const form = this.$refs.form.form;

        form.batch(() => {
            const idState = form.getFieldState('id');
            const fieldName = 'id';
            form.change(fieldName, input);
            form.mutators.setFieldTouched(fieldName, true);
        });
    }

    public resetSearch() {
        this.item = null as any;
        const form = this.$refs.form.form;
        form.change('id', "");
        form.mutators.setFieldTouched("id", true);
        this.searchPending = false;
    }

    private validateSelection() {
        this.$emit('item-selected', this.item)
        this.submitting = true;
    }
}
